<template>
  <div class="not-found">
    <div class="card">
      <div class="animated-404">404</div>
      <h1>Oops! Page Not Found</h1>
      <p>It looks like this page doesn't exist or has been moved.</p>
      <router-link to="/" class="btn">Go Home</router-link>
    </div>
  </div>
</template>

<script setup></script>

<style scoped>
.not-found {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(135deg, #1e3c72, #2a5298);
  padding: 20px;
}

.card {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 40px;
  text-align: center;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.2);
  max-width: 400px;
  width: 100%;
}

.animated-404 {
  font-size: 80px;
  font-weight: bold;
  color: white;
  animation: bounce404 1.5s infinite alternate;
}

@keyframes bounce404 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.1);
  }
}

/* Text Styling */
h1 {
  font-size: 26px;
  margin: 10px 0;
  color: white;
}

p {
  font-size: 16px;
  color: white;
  margin-bottom: 20px;
}

/* Button styling */
.btn {
  display: inline-block;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: bold;
  color: #1e3c72;
  background: white;
  border-radius: 50px;
  text-decoration: none;
  transition: 0.3s;
}

.btn:hover {
  background: #f1f1f1;
}
</style>
